import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { campaignsApi } from './api.js';
import { LEVEL_PATH } from './format.js';
import { LIST_STALE_MS, QUERY_DEFAULTS, REFERENCE_STALE_MS } from './query-policy.js';
/** Корень ключей раздела (мутации сбрасывают его целиком). */
export const KEY = ['ads-campaigns'];
const listKey = (account, p) => [...KEY, 'list', account, p];
const childrenKey = (account, id, day) => [...KEY, 'children', account, id, day ?? ''];
export const useHealth = () => useQuery({
    ...QUERY_DEFAULTS,
    queryKey: ['ads-campaigns-ref', 'health'],
    queryFn: campaignsApi.health,
    staleTime: REFERENCE_STALE_MS,
});
export const useAccounts = () => useQuery({
    ...QUERY_DEFAULTS,
    queryKey: ['ads-campaigns-ref', 'accounts'],
    queryFn: campaignsApi.accounts,
    staleTime: REFERENCE_STALE_MS,
});
export const useCampaignList = (account, p) => useQuery({
    ...QUERY_DEFAULTS,
    queryKey: listKey(account ?? '', p),
    queryFn: ({ signal }) => campaignsApi.list(account, p, { signal }),
    enabled: account !== undefined,
    staleTime: LIST_STALE_MS,
    placeholderData: keepPreviousData,
});
export const useCampaignChildren = (account, campaignId, enabled, day) => useQuery({
    ...QUERY_DEFAULTS,
    queryKey: childrenKey(account, campaignId, day),
    queryFn: () => campaignsApi.children(account, campaignId, day),
    enabled,
    staleTime: LIST_STALE_MS,
});
export const useStatusCheck = (account, kind, id, action) => useQuery({
    ...QUERY_DEFAULTS,
    queryKey: [...KEY, 'status', account, kind, id, action],
    queryFn: () => campaignsApi.statusCheck(account, LEVEL_PATH[kind], id, action),
    // проверка свежая каждый раз: решение принимается по ней
    staleTime: 0,
    gcTime: 0,
});
export function useInvalidate() {
    const qc = useQueryClient();
    return () => qc.invalidateQueries({ queryKey: KEY });
}
export function usePause(account, kind, id) {
    const inv = useInvalidate();
    return useMutation({
        mutationFn: (body) => campaignsApi.pause(account, LEVEL_PATH[kind], id, body),
        onSuccess: () => void inv(),
    });
}
export function useEnable(account, kind, id) {
    const inv = useInvalidate();
    return useMutation({
        mutationFn: (body) => campaignsApi.enable(account, LEVEL_PATH[kind], id, body),
        onSuccess: () => void inv(),
    });
}
export function useSync(account) {
    const inv = useInvalidate();
    return useMutation({
        mutationFn: (campaignId) => campaignsApi.sync(account, campaignId),
        onSuccess: () => void inv(),
    });
}
//# sourceMappingURL=queries.js.map